"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
* Created on Thu Aug 02 2018
*/

var DomainObject_1 = require("../../../core/model/DomainObject");
/**
 * Define the relations with the relevant competitors. Only one strategy and distance can be applied.
 *
 * @author RV
 */


var Strategy =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(Strategy, _DomainObject_1$Domai);

  function Strategy() {
    _classCallCheck(this, Strategy);

    return _possibleConstructorReturn(this, _getPrototypeOf(Strategy).apply(this, arguments));
  }

  return Strategy;
}(DomainObject_1.DomainObject);

exports.Strategy = Strategy;